import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZelle = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "1em",
	height: "1em",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Zelle Icon 2",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M8.88731 15H7.27035C7.19744 15 7.12752 14.9703 7.07596 14.9175C7.02441 14.8646 6.99545 14.793 6.99545 14.7182V13.1053H4.37906C4.27857 13.1052 4.18224 13.0642 4.11119 12.9914C4.04013 12.9185 4.00015 12.8198 4 12.7168V11.4137C4.00006 11.3266 4.0285 11.242 4.08082 11.1733L8.71315 5.11717H4.5868C4.48611 5.11717 4.38955 5.07617 4.31836 5.00321C4.24717 4.93024 4.20717 4.83127 4.20717 4.72808V3.28317C4.20717 3.06908 4.37735 2.89467 4.58623 2.89467H6.99374V1.28175C6.99374 1.12658 7.11725 1 7.26864 1H8.8856C9.03699 1 9.1605 1.12658 9.1605 1.28175V2.89467H11.6209C11.8298 2.89467 12 3.06908 12 3.28317V4.52975C11.9999 4.61638 11.9716 4.70051 11.9197 4.76892L7.25839 10.8828H11.6209C11.8298 10.8828 12 11.0572 12 11.2713V12.7162C12 12.8193 11.9601 12.9182 11.889 12.9912C11.8179 13.0641 11.7215 13.1052 11.6209 13.1053H9.16221V14.7182C9.16221 14.793 9.13325 14.8646 9.08169 14.9175C9.03014 14.9703 8.96022 15 8.88731 15Z",
			fill: "var(--fill-0, #6534D1)"
		})
	})
});
export default SvgZelle;
